import { NavigateFunction } from "react-router-dom";

export const addFilter = (
  navigate: NavigateFunction,
  param: string,
  value: string,
  multiple = false,
) => {
  const url = new URL(location.href);
  if (multiple) {
    if (!url.searchParams.has(param, value)) {
      url.searchParams.append(param, value);
    }
  } else {
    url.searchParams.set(param, value);
  }
  navigate(url.href.replace(url.origin, ""));
};

export const removeFilter = (
  navigate: NavigateFunction,
  param: string,
  value?: string,
) => {
  const url = new URL(location.href);
  url.searchParams.delete(param, value);
  navigate(url.href.replace(url.origin, ""));
};

export const setFilter = (
  navigate: NavigateFunction,
  param: string,
  value: string,
) => {
  const url = new URL(location.href);
  url.searchParams.set(param, value);
  navigate(url.href.replace(url.origin, ""));
};

export const resetFilters = (navigate: NavigateFunction) => {
  const url = new URL(location.href);
  url.searchParams.delete("riskRating");
  url.searchParams.delete("platform");
  url.searchParams.delete("name");
  url.searchParams.delete("label");
  url.searchParams.delete("annotation");
  url.searchParams.delete("queryTerm");
  url.searchParams.delete("assetUrlFilter");
  navigate(url.href.replace(url.origin, ""));
};

export default function buildWorkflowMrn(
  spaceId: string | undefined,
  workflowId: string | undefined,
): string {
  if (!spaceId || !workflowId) {
    throw new Error(
      "spaceId and workflowId are required to build workflow MRN",
    );
  }
  return `//policy.api.mondoo.app/spaces/${spaceId}/workflows/${workflowId}`;
}

type GetWorkflowUrlParams = {
  workflowMrn: string;
  params: URLSearchParams | undefined;
};

export function getWorkflowUrl({
  workflowMrn,
  params,
}: GetWorkflowUrlParams): string {
  return `/space/integrations/workflows/${workflowMrn.split("/").pop()}?${params?.toString()}`;
}
